export function hasRoleManagemetPermission(permissions: string[]): boolean {
  for (const permission of permissions) {
    if (permission.indexOf('RoleManagement:') !== -1) {
      return true;
    }
  }
  return false;
}

export function hasBlueprintManagementPermission(permissions: string[]): boolean {
  for (const permission of permissions) {
    if (permission.indexOf('BlueprintManagement:') !== -1) {
      return true;
    }
  }
  return false;
}

/**
 * Checks if the user has Blueprint Builder permissions.
 * @param permissions list of permissions signed in user has
 * @returns true if the user has Blueprint Builder permissions, false otherwise
 */
export function hasBlueprintBuilderPermission(permissions: string[]): boolean {
  return (
    permissions.includes('BlueprintManagement:BuildBlueprint') ||
    permissions.includes('BlueprintManagement:GenerateUserReport')
  );
}

export function hasPromptManagementPermission(permissions: string[]): boolean {
  for (const permission of permissions) {
    if (permission.indexOf('PromptManagement:') !== -1) {
      return true;
    }
  }
  return false;
}

export function hasWebflowManagementPermission(permissions: string[]): boolean {
  for (const permission of permissions) {
    if (permission.indexOf('WebflowManagement:') !== -1) {
      return true;
    }
  }
  return false;
}

export function hasGuideManagementPermission(permissions: string[]): boolean {
  for (const permission of permissions) {
    if (permission.indexOf('GuideManagement:') !== -1) {
      return true;
    }
  }
  return false;
}

export function hasLeadManagementPermission(permissions: string[]): boolean {
  for (const permission of permissions) {
    if (permission.indexOf('LeadManagement:') !== -1) {
      return true;
    }
  }
  return false;
}

export function hasDeveloperPermission(permissions: string[]): boolean {
  for (const permission of permissions) {
    if (permission.indexOf('Developer:') !== -1 || permission.indexOf('RoleManagement:') !== -1) {
      return true;
    }
  }
  return false;
}

export function hasCalendarManagementPermission(permissions: string[]): boolean {
  for (const permission of permissions) {
    if (permission.indexOf('CalendarManagement:') !== -1) {
      return true;
    }
  }
  return false;
}

export function hasCalendarManagementAdminPermission(permissions: string[]): boolean {
  for (const permission of permissions) {
    if (permission === 'CalendarManagement:ManageAllCalendars') {
      return true;
    }
  }
  return false;
}
